import { render } from "./App.vue?vue&type=template&id=34e44de4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=34e44de4&lang=scss"

import exportComponent from "/home/franck_boullier/Documents/bitbucket/exchange-app-admin-vue-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__